<template>
  <div class="wt2-dialog wt2-confirm-dialog wt2-confirm-3-dialog">
    <general-dialog-layout>
      <div slot="main" class="-dialog-main">
        <div class="-title-box">
          <span class="wt2-text-xl" :class="titleColorClass">{{ title }}</span>
        </div>
        <div class="-description-box">
          <span class="wt2-text-n wt2-color-normal" v-html="description"></span>
          <dialog-contact-csm
            v-if="showContactCsm"
            :csm-sentence-text="csmSentenceText"
            :csm-link-text="csmLinkText"
            :csm-sentence-text-end="csmSentenceTextEnd"
            :csm-chat-message="csmChatMessage"
          />
        </div>
      </div>
      <dialog-footer slot="footer">
        <div slot="buttons">
          <wt-button
            tabindex="-1"
            type="transparent"
            :text="buttonNoText"
            @click="action($event, buttonNoAction)"
          ></wt-button>
          <wt-button
            class="-action-yes"
            tabindex="0"
            :type="primaryBtnType"
            :text="buttonYesText"
            @click="
              action($event, buttonYesAction, {
                checkboxValue: checkboxModel,
              })
            "
          ></wt-button>
        </div>
        <dialog-checkbox
          slot="right"
          v-bind="$props"
          :checkbox.sync="checkboxModel"
          v-if="showCheckbox"
        ></dialog-checkbox>
      </dialog-footer>
    </general-dialog-layout>
  </div>
</template>

<script>
import propsMixin from '../mixins/propsMixin.vue';
import methodsMixin from '../mixins/methodsMixin.vue';
import dataMixin from '../mixins/dataMixin.vue';
import GeneralDialogLayout from '../parts/GeneralDialogLayout.vue';
import DialogFooter from '../parts/DialogFooter.vue';
import DialogCheckbox from '../parts/DialogCheckbox.vue';
import DialogContactCsm from '../parts/DialogContactCsm.vue';

export default {
  mixins: [propsMixin, methodsMixin, dataMixin],
  components: {
    GeneralDialogLayout,
    DialogFooter,
    DialogCheckbox,
    DialogContactCsm,
  },
};
</script>
